import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useSidebar } from '../contexts/SidebarContext';
import { formatRole } from '../utils/utils';

export const TopBar: React.FC = () => {
    const navigate = useNavigate();
    const { user } = useAuth();
    const { open: openSidebar } = useSidebar();

    const initial = user?.name ? user.name.charAt(0).toUpperCase() : 'U';

    return (
        <header className="bg-warm-50 border-b border-warm-200 px-4 lg:px-6 py-3 flex justify-between items-center sticky top-0 z-10">

            <button
                onClick={openSidebar}
                className="lg:hidden p-2 -ml-2 rounded-lg text-gray-700 hover:bg-warm-100 transition-colors"
                aria-label="Apri menu"
            >
                <Menu size={22} />
            </button>

            <div className="flex items-center space-x-4 ml-auto">
                <button onClick={() => navigate('/profilo')} className="flex items-center gap-3 hover:bg-warm-100 p-1.5 rounded-lg transition-colors">
                    <div className="text-right hidden sm:block">
                        <div className="text-sm font-semibold text-gray-800">
                            {user?.name} {user?.surname}
                        </div>
                        <div className="text-xs text-gray-400 uppercase tracking-wide">
                            {formatRole(user?.role) || 'Utente'}
                        </div>
                    </div>
                    <div className="w-10 h-10 rounded-full bg-gradient-to-br from-brand-700 to-brand-900 flex items-center justify-center text-white font-bold shadow-sm border-2 border-white">
                        {initial}
                    </div>
                </button>
            </div>
        </header>
    );
}
